import { projectToCRS } from "@nova/calculate-geospatial"
import { HotspotWithDistance } from "@nova/constants"
import { FeatureCollection } from "geojson"
export const polygonTransformer = (hotspots: HotspotWithDistance[], projection?: string) => {
    const json = { type: "FeatureCollection", features: [] } as FeatureCollection
    hotspots.forEach((hotspot) => {
        if (!hotspot.polygon?.length) return
        json.features.push({
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    hotspot.polygon.map((point) =>
                        projectToCRS([point.longitude, point.latitude], projection)
                    ),
                ],
            },
            properties: {
                id: hotspot.id,
            },
        })
    })
    return json
}
